<template>
    <section class="callout-slice">
        <PrismicRichText v-if="slice.variation === 'default'" :field="slice.primary.content" class="content" />
        <div v-else class="callout-grid">
            <PrismicRichText :field="slice.primary.left" class="content left" />
            <PrismicRichText :field="slice.primary.right" class="content right" />
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {CalloutSlice} from '@prismicio-types';
    defineProps(getSliceComponentProps<CalloutSlice>());
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;

    .callout-slice {
        background-color: var(--joy-color-quaternary-10);
        padding: var(--joy-core-spacing-9);
        margin-top: var(--joy-core-spacing-11);
        margin-bottom: var(--joy-core-spacing-11);
        @include content-width($article-max-width);

        .content {
            display: flex;
            flex-direction: column;
            gap: var(--joy-core-spacing-4);
            justify-content: flex-start;
        }
        .callout-grid {
            display: flex;
            justify-content: space-between;
            gap: var(--joy-core-spacing-12);
            .left {
                flex-basis: 70%;
            }
            .right {
                flex-basis: 30%;
                p {
                    font-size: var(--joy-font-size-primary-300);
                }
                img {
                    width: 100%;
                    max-height: 200px;
                    object-fit: contain;
                    object-position: right;
                }
            }
            @media (max-width: $mobile-breakpoint) {
                flex-direction: column;
                gap: var(--joy-core-spacing-7);

                .left {
                    flex-basis: unset;
                    order: 2;
                }
                .right {
                    flex-basis: unset;
                    p {
                        font-size: var(--joy-font-size-primary-400);
                    }
                    img {
                        object-position: center;
                    }
                }
            }
        }

        /* Themes */
        .resource-page--corporate &,
        .resource-page--strategy & {
            background-color: var(--joy-color-neutral-20);
        }
    }
</style>
